import React, { Component } from 'react';
import { Form } from '@ant-design/compatible';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
import { DatePicker, Select, Input, Button } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Calendar } from '@carbon/icons-react';
import * as assetActions from '../../../core/asset/assetActions';

const { DB_DATE_FORMAT } = require('../../../core/constants').default;

class DriverManagementAlertsForm extends Component {
    componentDidMount() {
        const { actions } = this.props;

        actions.getAssetListRequest();
    }

    submitForm = (e) => {
        const { onSubmit } = this.props;

        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                onSubmit(values);
            }
        });
    };

    hasErrors(fieldsError) {
        return Object.keys(fieldsError).some((field) => fieldsError[field]);
    }

    render() {
        const { form, serviceAlert, clearForm } = this.props;
        
        const { getFieldDecorator, getFieldsError } = form;
        if (serviceAlert.name === null) {
            // means new alert, set frequency to undefined to show the placeholder
            serviceAlert.frequency = undefined;
        }

        return (
            <div className="d-flex dir-column align-center mt-1">
                <Form
                    layout="vertical"
                    style={{
                        width: '100%',
                        maxWidth: 304,
                        paddingBottom: 16,
                    }}
                    onSubmit={this.submitForm}
                >
                    <Form.Item label="Name">
                        {getFieldDecorator('alert_name', {
                            initialValue: (serviceAlert.name || ''),
                            rules: [
                                {
                                    required: true,
                                    message: 'Alert name is required',
                                },
                            ],

                        })(
                            <Input 
                                placeholder="Enter Name" 
                                data-testid='create-edit-management-alert_name-input'
                            />
                        )}
                    </Form.Item>
                    <Form.Item label="Description">
                        {getFieldDecorator('alert_description', {
                            initialValue: (serviceAlert.description || ''),
                            rules: [
                                {
                                    required: true,
                                    message: 'Alert description is required',
                                },
                            ],
                        })(
                            <Input.TextArea
                                placeholder="Enter Description"
                                style={{ height: 112 }} 
                                data-testid='create-edit-management-alert_description-input'
                            />
                        )}
                    </Form.Item>
                    <Form.Item label="Service Date">
                        {getFieldDecorator('service_date', {
                            initialValue: serviceAlert.service_date ? dayjs(serviceAlert.service_date, DB_DATE_FORMAT) : dayjs(),
                            rules: [
                                {
                                    required: true,
                                    message: 'Service date is required',
                                },
                            ],
                        })(
                            <DatePicker 
                                format={DB_DATE_FORMAT} 
                                placeholder="Select Service Date" 
                                allowClear={false}
                                suffixIcon={<Calendar />}
                                data-testid='create-edit-management-alert_date-picker'
                            />
                        )}
                    </Form.Item>
                    <Form.Item label="Frequency">
                        {getFieldDecorator('alert_frequency', {
                            initialValue: serviceAlert.frequency,
                            rules: [
                                {
                                    required: true,
                                    message: 'Alert frequency is required',
                                },
                            ],
                        })(
                            <Select
                                placeholder="Select Frequency"
                                data-testid='create-edit-management-alert_frequency-select'
                            >
                                <Select.Option value={2}>Monthly</Select.Option>
                                <Select.Option value={1}>Quarterly</Select.Option>
                                <Select.Option value={0}>Yearly</Select.Option>
                            </Select>
                        )}
                    </Form.Item>
                    <div style={{ 
                        textAlign: 'center', 
                        margintop: '20px' 
                    }}>
                        <div>
                            
                            <Button
                                style={{ width: 'auto' }}
                                htmlType="button"
                                onClick={clearForm}
                                className="btn btn-bordered"
                                data-testid='create-edit-management-alert_cancel-btn'
                            >
                                Cancel
                            </Button>
                            <Button
                                style={{ marginLeft: '16px' }}
                                htmlType="submit"
                                type="primary"
                                disabled={this.hasErrors(getFieldsError())}
                                data-testid='create-edit-management-alert_confirm-btn'
                            >
                                Add
                            </Button>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
}

const CreateManagementAlertForm = Form.create({ name: 'event_filter_form' })(DriverManagementAlertsForm);

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        assetList: state.asset.assetList,
        companyUsers: state.user.companyUsers,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...assetActions,
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CreateManagementAlertForm);
